import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { marqueeWords } from "../../data/content";

// Editorial running marquee (luxury Framer pattern)
const Marquee = () => {
  const { isAr } = useLang();
  const words = isAr ? marqueeWords.ar : marqueeWords.en;
  // Repeat for seamless scroll
  const repeated = [...words, ...words, ...words, ...words];

  return (
    <section
      className="relative bg-bg-ivory border-y border-brand-green/15 py-10 md:py-14 overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="flex whitespace-nowrap">
        <motion.div
          className="flex gap-12 md:gap-20"
          animate={{ x: isAr ? ["0%", "50%"] : ["0%", "-50%"] }}
          transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        >
          {repeated.map((w, i) => (
            <div key={i} className="flex items-center gap-12 md:gap-20 shrink-0">
              <span
                className={`${isAr ? "arabic-title" : "serif-title italic"} text-brand-green`}
                style={{ fontSize: "clamp(28px, 4vw, 56px)", fontWeight: isAr ? 500 : 300 }}
              >
                {w}
              </span>
              <span
                className="text-brand-green/40"
                style={{ fontSize: 24 }}
              >
                ✦
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Marquee;
